export type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'expired';
export type ApprovalKind =
  | 'invoice.high_value'
  | 'invitation.outside_org'
  | 'role.elevation'
  | 'data.export'
  | 'expense.reimbursement';

export interface MockApproval {
  readonly id: string;
  readonly orgId: string;
  readonly subject: string;
  readonly kind: ApprovalKind;
  readonly requiredCapability: string;
  readonly requestedByUserId: string;
  readonly requestedByName: string;
  readonly requestedAt: string;
  readonly expiresAt: string;
  status: ApprovalStatus;
  decisionByUserId?: string;
  decisionAt?: string;
  decisionNote?: string;
  readonly payload: Record<string, unknown>;
}

export const MOCK_APPROVALS: MockApproval[] = [
  {
    id: '01HZA3CB6MKQ9X2TYAPP00001', orgId: 'acme',
    subject: 'Invoice INV-2026-04-0042 · $14,200', kind: 'invoice.high_value',
    requiredCapability: 'books.invoice.approve',
    requestedByUserId: '01HZP3CB6MKQ9X2TYACME002', requestedByName: 'Acme Auditor',
    requestedAt: '2026-04-28T11:30:00-05:00', expiresAt: '2026-05-05T11:30:00-05:00',
    status: 'pending',
    payload: { invoiceId: 'INV-2026-04-0042', amount: 14200, currency: 'USD' },
  },
  {
    id: '01HZA3CB6MKQ9X2TYAPP00002', orgId: 'acme',
    subject: 'Invite collab@vendor.test as external_collaborator', kind: 'invitation.outside_org',
    requiredCapability: 'users.invite',
    requestedByUserId: '01HZP3CB6MKQ9X2TYACME003', requestedByName: 'Robin Patel',
    requestedAt: '2026-04-27T15:10:00-05:00', expiresAt: '2026-05-04T15:10:00-05:00',
    status: 'pending',
    payload: { email: 'collab@vendor.test', role: 'external_collaborator' },
  },
  {
    id: '01HZA3CB6MKQ9X2TYAPP00003', orgId: 'acme',
    subject: 'Promote Jordan Lee to org_admin', kind: 'role.elevation',
    requiredCapability: 'platform.role.grant',
    requestedByUserId: '01HZP3CB6MKQ9X2TYACME004', requestedByName: 'Casey Tanaka',
    requestedAt: '2026-04-25T09:30:00-05:00', expiresAt: '2026-05-02T09:30:00-05:00',
    status: 'approved', decisionByUserId: '01HZS3CB6MKQ9X2TYOWNERUS',
    decisionAt: '2026-04-26T14:30:00-05:00', decisionNote: 'Approved per quarterly review.',
    payload: { targetUserId: '01HZP3CB6MKQ9X2TYACME005', role: 'org_admin' },
  },
  {
    id: '01HZA3CB6MKQ9X2TYAPP00004', orgId: 'acme',
    subject: 'Export user records for compliance audit', kind: 'data.export',
    requiredCapability: 'audit.export',
    requestedByUserId: '01HZP3CB6MKQ9X2TYACME002', requestedByName: 'Acme Auditor',
    requestedAt: '2026-04-22T08:00:00-05:00', expiresAt: '2026-04-29T08:00:00-05:00',
    status: 'rejected', decisionByUserId: '01HZS3CB6MKQ9X2TYOWNERUS',
    decisionAt: '2026-04-22T17:00:00-05:00',
    decisionNote: 'Insufficient scope. Re-submit with the data-residency form.',
    payload: { format: 'csv', scope: 'all_users' },
  },
  {
    id: '01HZA3CB6MKQ9X2TYAPP00005', orgId: 'acme-eu',
    subject: 'Expense reimbursement · €2,840 (Q1 travel)', kind: 'expense.reimbursement',
    requiredCapability: 'books.invoice.approve',
    requestedByUserId: '01HZP3CB6MKQ9X2TYACEU003', requestedByName: 'Aoife Murphy',
    requestedAt: '2026-04-26T10:00:00+01:00', expiresAt: '2026-05-03T10:00:00+01:00',
    status: 'pending',
    payload: { amount: 2840, currency: 'EUR', category: 'travel' },
  },
  {
    id: '01HZA3CB6MKQ9X2TYAPP00006', orgId: 'acme-eu',
    subject: 'Invite cillian.b@acme-eu.test as Account Executive', kind: 'invitation.outside_org',
    requiredCapability: 'users.invite',
    requestedByUserId: '01HZP3CB6MKQ9X2TYACEU001', requestedByName: "Niamh O'Brien",
    requestedAt: '2026-04-22T09:00:00+01:00', expiresAt: '2026-04-29T09:00:00+01:00',
    status: 'pending',
    payload: { email: 'cillian.b@acme-eu.test', role: 'org_member' },
  },
  {
    id: '01HZA3CB6MKQ9X2TYAPP00007', orgId: 'brava',
    subject: 'Promote Lukas Schmidt to senior engineer', kind: 'role.elevation',
    requiredCapability: 'platform.role.grant',
    requestedByUserId: '01HZP3CB6MKQ9X2TYBRAV001', requestedByName: 'Brava Admin',
    requestedAt: '2026-04-15T09:00:00+01:00', expiresAt: '2026-04-22T09:00:00+01:00',
    status: 'expired',
    payload: { targetUserId: '01HZP3CB6MKQ9X2TYBRAV005', role: 'senior_engineer' },
  },
];
